<script>
import { mockupResendMailMethods } from '@/state/sendMailHelpers'
export default {
  methods: {
    ...mockupResendMailMethods,
    handleChangePageSearchBooking() {
      this.sendMailInit()
      this.$router.push({ path: `/booking-info/search-booking` })
    },
  },
}
</script>

<template>
  <div>
    <v-img
      :src="require('@assets/images/success.png')"
      contain
      aspect-ratio="1.5"
      width="200"
      class="ma-auto"
    />
    <p class="white--text font-weight-bold mt-5 mb-10"> {{ $t('sendMail') }}</p>
    <BaseButtonMainCard label="ok" @click="handleChangePageSearchBooking" />
  </div>
</template>

<style lang="scss">
@import '@design';
</style>
